import { useSelector } from "react-redux";
import { createSelector } from "reselect";

const selectUserPermissions = createSelector(
  state => {
    const roles = state.authme.data?.roles;

    if (!roles || roles.length === 0) {
      return [];
    }

    // جمع كل permissions من كل roles
    return roles.flatMap(role => role.permessions || []);
  },
  permissions =>
    permissions.map(perm => perm.name)
  
);



function usePermissions() {
 const userPermissions = useSelector(selectUserPermissions);

//check for permissions 

 const hasPermission = (permission) => userPermissions.includes(permission);

 const checkPermissionAndThrow = (permission) => {
   if (!hasPermission(permission)) {
     return false;
   }
   else{
     return true;
   }
 };    


return { checkPermissionAndThrow , userPermissions }; 
    
}

export default usePermissions;  